import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const ChatImage = ({ src, alt = '', className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  return (
    <>
      <img
        src={src}
        alt={alt}
        className={`${className} chat-image-clickable`.trim()}
        onClick={() => setIsOpen(true)}
      />

      {isOpen && createPortal(
        <div
          className="chat-image-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Просмотр изображения"
          onClick={() => setIsOpen(false)}
        >
          <button
            type="button"
            className="chat-image-lightbox-close"
            aria-label="Закрыть изображение"
            onClick={() => setIsOpen(false)}
          >
            ×
          </button>
          <img
            src={src}
            alt={alt}
            className="chat-image-lightbox-content"
            onClick={(event) => event.stopPropagation()}
          />
        </div>,
        document.body
      )}
    </>
  );
};

export default ChatImage;
